module.exports = __webpack_public_path__ + "static/media/feature_img_2.09307606.png";